import { render } from "./AnimatedWords.vue?vue&type=template&id=3a11f93c&scoped=true"
import script from "./AnimatedWords.vue?vue&type=script&lang=js"
export * from "./AnimatedWords.vue?vue&type=script&lang=js"

import "./AnimatedWords.vue?vue&type=style&index=0&id=3a11f93c&scoped=true&lang=css"

import exportComponent from "/Users/noursafadi/Documents/Uni/Parsons-Spring-25/MajorStudio02/MSDV-thesis-2025/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a11f93c"]])

export default __exports__